import { render, staticRenderFns } from "./CameraPageShootCardAutoMyNumberCardDiagonal1.vue?vue&type=template&id=64027703&"
import script from "./CameraPageShootCardAutoMyNumberCardDiagonal1.vue?vue&type=script&lang=ts&"
export * from "./CameraPageShootCardAutoMyNumberCardDiagonal1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports